import type { CellKeyOf } from "./types";

export const cellKeyOf: CellKeyOf = ({ buildingCode, levelCode }) =>
  `${buildingCode}|${levelCode}`;
